module.exports = __webpack_public_path__ + "static/media/Bootstrap_Badge.1704dd76.png";